// Sandbox
export var FA_USER_CIRCLE = ['fas', 'user-circle'];
export var FA_GLOBE = ['fal', 'globe'];
// CBR
export var FA_DONATE = ['fal', 'donate'];
export var FA_ENVELOPE = ['fal', 'envelope'];
export var FA_CIRCLE_CHECK = ['fal', 'circle-check'];
export var FA_DOLLAR_SIGN = ['fal', 'dollar-sign'];
export var FA_HOUSE = ['fal', 'house'];
